"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CombiPdReasonForTestingDtoPregnancyTerminatedEnum = exports.CombiPdReasonForTestingDtoPgtaResultsEnum = exports.CombiPdReasonForTestingDtoNipsLabEnum = exports.CombiPdReasonForTestingDtoFetalKaryotypeEnum = exports.CombiPdReasonForTestingDtoFetalSexEnum = exports.CombiPdReasonForTestingDtoPregnancyTypeEnum = void 0;
exports.CombiPdReasonForTestingDtoPregnancyTypeEnum = {
    Singleton: 'Singleton',
    Twins: 'Twins',
    Triplets: 'Triplets'
};
exports.CombiPdReasonForTestingDtoFetalSexEnum = {
    Unknown: 'Unknown',
    Female: 'Female',
    Male: 'Male',
    Ambiguous: 'Ambiguous'
};
exports.CombiPdReasonForTestingDtoFetalKaryotypeEnum = {
    Pending: 'Pending',
    _46Xx: '46,XX',
    _46Xy: '46,XY',
    Abnormal: 'Abnormal'
};
exports.CombiPdReasonForTestingDtoNipsLabEnum = {
    InvitaeInvitaeNips: 'Invitae - Invitae NIPS',
    AveroPrenatalScreen: 'AVERO - Prenatal Screen',
    CounsylMyriadPrelude: 'Counsyl/Myriad - Prelude',
    IllumniaVerifi: 'Illumnia - Verifi',
    IlluminaVerifi: 'Illumina - Verifi',
    IntegratedGeneticsInformaSeq: 'Integrated Genetics - InformaSeq',
    NateraVistara: 'Natera - Vistara',
    NateraPanorama: 'Natera - Panorama',
    OpkoClaritest: 'OPKO - Claritest',
    ProgenityInnatal: 'Progenity - Innatal',
    ProgenityResura: 'Progenity - Resura',
    QuestQNatal: 'Quest - QNatal',
    RocheHarmony: 'Roche - Harmony',
    SequenomMaterniTGenome: 'Sequenom - MaterniT Genome',
    SequenomMaterniT21Plus: 'Sequenom - MaterniT21 PLUS',
    NxGenMdxNipt: 'NxGenMDx - NIPT',
    Other: 'Other'
};
exports.CombiPdReasonForTestingDtoPgtaResultsEnum = {
    Abnormal: 'Abnormal',
    Normal: 'Normal'
};
exports.CombiPdReasonForTestingDtoPregnancyTerminatedEnum = {
    SabIufd: 'SAB/IUFD',
    Tab: 'TAB'
};
